import { permisionByModule } from '../../utils'
export const TOOGLE_ALERT = 'TOOGLE_ALERT'
export const TOOGLE_ALERT_INFO = 'TOOGLE_ALERT_INFO'
export const TOOGLE_ALERT_MODULE = 'TOOGLE_ALERT_MODULE'
export const ALERT_RESET_REDUX = 'ALERT_RESET_REDUX'

export const alertReset = () => ({
  type: ALERT_RESET_REDUX
})
export const toggleAlert = (show = false, title = 'Unable to connect to the internet', icon =  ["fas","wifi-slash"],  type = '', disabledCloseButton = false, form = {}) => ({
  type: TOOGLE_ALERT,
  payload: { show, type, title, icon, disabledCloseButton, form }
})

export const toggleAlertInfo = (show = false, title, subtitle, type) => ({
  type: TOOGLE_ALERT_INFO,
  payload: { show, title, subtitle, type }
})

export const toggleAlertModule = (show = false, module = '', mode = null,  onSave = null, onDontSave = null) => ({
  type: TOOGLE_ALERT_MODULE,
  payload: { show, module, mode, onSave, onDontSave }
})

export const authorized = (module, permissions) => {
  return dispatch => {
    if (permisionByModule(permissions, module)) {
      dispatch(toggleAlert())
    } else {
      dispatch(toggleAlert(true, 'Not authorized', 'ban', 'UnAuthorized', true))
    }
  }
}
